module.exports = __webpack_public_path__ + "img/v04.c6fda989.jpg";